import axios from 'axios';

// Public submissions must not inherit the authenticated client’s token interceptor.
const publicClient = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL });

const submitAnnualReportByTrackingId = (data) => {
  const url = '/organizations/by-tracking-id/submit-yearly-report/';
  if (data instanceof FormData) return publicClient.post(url, data);
  return publicClient.post(url, data, { headers: { 'Content-Type': 'application/json' } });
};

export default submitAnnualReportByTrackingId;
